export const STUDIO_OVERVIEW_WORKSPACE_ID = "studio:overview";
export const STUDIO_OVERVIEW_REFRESH_MS = 15_000;
